import { render, staticRenderFns } from "./AplicationsComponent.vue?vue&type=template&id=32b10854"
import script from "./AplicationsComponent.vue?vue&type=script&lang=js"
export * from "./AplicationsComponent.vue?vue&type=script&lang=js"
import style0 from "./AplicationsComponent.vue?vue&type=style&index=0&id=32b10854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports